import { Controller } from "@hotwired/stimulus"

// Minimal controller for a single condition row
// Only handles operator dropdown updates when property changes
export default class extends Controller {
  static targets = ["propertySelect", "operatorSelect"]
  static values = { requestType: String }

  updateOperators() {
    const property = this.propertySelectTarget.value
    const operators = this.getOperatorsForProperty(property)

    this.operatorSelectTarget.innerHTML = operators
      .map(op => `<option value="${op.value}">${op.label}</option>`)
      .join('')
  }

  getOperatorsForProperty(property) {
    // Use operator mapping generated from Ruby (single source of truth)
    const mapping = window.operatorMapping || {}
    return mapping[property] || [
      { value: 'equals', label: 'equals' },
      { value: 'not_equals', label: 'does not equal' }
    ]
  }
}
